/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResponseData_Array_CurrencyDictionaryResponse_CryptoCurrencyEnum } from '../models/ResponseData_Array_CurrencyDictionaryResponse_CryptoCurrencyEnum';
import type { ResponseData_Array_CurrencyDictionaryResponse_Int32 } from '../models/ResponseData_Array_CurrencyDictionaryResponse_Int32';
import type { ResponseData_Array_DictionaryEnumResponse_ApplicationDocumentTypeEnum } from '../models/ResponseData_Array_DictionaryEnumResponse_ApplicationDocumentTypeEnum';
import type { ResponseData_Array_DictionaryEnumResponse_CountryEnum } from '../models/ResponseData_Array_DictionaryEnumResponse_CountryEnum';
import type { ResponseData_Array_DictionaryEnumResponse_DefinitionActionKindEnum } from '../models/ResponseData_Array_DictionaryEnumResponse_DefinitionActionKindEnum';
import type { ResponseData_Array_DictionaryEnumResponse_EpochEnum } from '../models/ResponseData_Array_DictionaryEnumResponse_EpochEnum';
import type { ResponseData_Array_DictionaryEnumResponse_OrganizationDocumentTypeEnum } from '../models/ResponseData_Array_DictionaryEnumResponse_OrganizationDocumentTypeEnum';
import type { ResponseData_Array_DictionaryEnumResponse_ProcessTypeEnum } from '../models/ResponseData_Array_DictionaryEnumResponse_ProcessTypeEnum';
import type { ResponseData_Array_DictionaryEnumResponse_RoleEnum } from '../models/ResponseData_Array_DictionaryEnumResponse_RoleEnum';
import type { ResponseData_Array_DictionaryEnumResponse_TicketCategoryEnum } from '../models/ResponseData_Array_DictionaryEnumResponse_TicketCategoryEnum';
import type { ResponseData_Array_DictionaryEnumResponse_TicketStatusEnum } from '../models/ResponseData_Array_DictionaryEnumResponse_TicketStatusEnum';
import type { ResponseData_CryptoNetDictionaryResponse } from '../models/ResponseData_CryptoNetDictionaryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DictionariesService {
    /**
     * Получить список стран
     * @returns ResponseData_Array_DictionaryEnumResponse_CountryEnum OK
     * @throws ApiError
     */
    public static getApiV1DictionariesCountries(): CancelablePromise<ResponseData_Array_DictionaryEnumResponse_CountryEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/countries',
        });
    }
    /**
     * Получить список валют
     * @returns ResponseData_Array_CurrencyDictionaryResponse_Int32 OK
     * @throws ApiError
     */
    public static getApiV1DictionariesCurrencies(): CancelablePromise<ResponseData_Array_CurrencyDictionaryResponse_Int32> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/currencies',
        });
    }
    /**
     * Получить список криптовалют
     * @returns ResponseData_Array_CurrencyDictionaryResponse_CryptoCurrencyEnum OK
     * @throws ApiError
     */
    public static getApiV1DictionariesCryptoCurrencies(): CancelablePromise<ResponseData_Array_CurrencyDictionaryResponse_CryptoCurrencyEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/cryptoCurrencies',
        });
    }
    /**
     * Получить список типов заявок
     * @returns ResponseData_Array_DictionaryEnumResponse_ProcessTypeEnum OK
     * @throws ApiError
     */
    public static getApiV1DictionariesProcessTypes(): CancelablePromise<ResponseData_Array_DictionaryEnumResponse_ProcessTypeEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/processTypes',
        });
    }
    /**
     * Получить список ролей
     * @returns ResponseData_Array_DictionaryEnumResponse_RoleEnum OK
     * @throws ApiError
     */
    public static getApiV1DictionariesRoles(): CancelablePromise<ResponseData_Array_DictionaryEnumResponse_RoleEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/roles',
        });
    }
    /**
     * Получить список действий
     * @returns ResponseData_Array_DictionaryEnumResponse_DefinitionActionKindEnum OK
     * @throws ApiError
     */
    public static getApiV1DictionariesActions(): CancelablePromise<ResponseData_Array_DictionaryEnumResponse_DefinitionActionKindEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/actions',
        });
    }
    /**
     * Получить список эпох
     * @returns ResponseData_Array_DictionaryEnumResponse_EpochEnum OK
     * @throws ApiError
     */
    public static getApiV1DictionariesEpochs(): CancelablePromise<ResponseData_Array_DictionaryEnumResponse_EpochEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/epochs',
        });
    }
    /**
     * Получить список сетей
     * @returns ResponseData_CryptoNetDictionaryResponse OK
     * @throws ApiError
     */
    public static getApiV1DictionariesNets(): CancelablePromise<Array<ResponseData_CryptoNetDictionaryResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/nets',
        });
    }
    /**
     * Получить список типов документов для заявки
     * @returns ResponseData_Array_DictionaryEnumResponse_ApplicationDocumentTypeEnum OK
     * @throws ApiError
     */
    public static getApiV1DictionariesApplicationDocumentTypes(): CancelablePromise<ResponseData_Array_DictionaryEnumResponse_ApplicationDocumentTypeEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/applicationDocumentTypes',
        });
    }
    /**
     * Получить список типов документов организации
     * @returns ResponseData_Array_DictionaryEnumResponse_OrganizationDocumentTypeEnum OK
     * @throws ApiError
     */
    public static getApiV1DictionariesOrganizationDocumentTypes(): CancelablePromise<ResponseData_Array_DictionaryEnumResponse_OrganizationDocumentTypeEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/organizationDocumentTypes',
        });
    }
    /**
     * Получить список категорий обращения
     * @returns ResponseData_Array_DictionaryEnumResponse_TicketCategoryEnum OK
     * @throws ApiError
     */
    public static getApiV1DictionariesTicketCategories(): CancelablePromise<ResponseData_Array_DictionaryEnumResponse_TicketCategoryEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/ticketCategories',
        });
    }
    /**
     * Получить список статусов обращения
     * @returns ResponseData_Array_DictionaryEnumResponse_TicketStatusEnum OK
     * @throws ApiError
     */
    public static getApiV1DictionariesTicketStatuses(): CancelablePromise<ResponseData_Array_DictionaryEnumResponse_TicketStatusEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dictionaries/ticketStatuses',
        });
    }
}
